module.exports = __webpack_public_path__ + "static/assets/4d89d58309c13d68fae3a79c7e99a77f.png";